<section class="c-section c-section--open" id="st-services">
	<div *ngIf="false" class="c-section__content">
		<div class="o-grid o-grid--wrap">
			<div class="o-grid__cell o-grid__cell--w-100 u-osb-md">
				<div class="c-card c-card--height-fit">
					<div class="c-content c-content--lg">
						<div class="o-grid o-grid--wrap">
							<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-50@md-and-up">
								<p class="c-text c-text--lg c-text--lg">
									{{'Poliisi XXXXX kehvitusega 27 märts 2020 kuni 27 märts 2024'}}
								</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up" style="text-align: right">
								<a class="c-button c-button--s1 c-button--narrow c-button--fit@up-to-sm">
									<i class="o-icon o-icon--download" aria-hidden="true"></i>
									{{ 'Laadi poliis alla' }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="c-section__content">
		<div class="o-grid o-grid--wrap">
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-osb-md">
				<div class="c-card c-card--height-fit">
					<div class="c-content c-content--lg">
						<div class="o-grid o-grid--wrap o-grid--center-h">
							<div class="o-grid__cell o-grid__cell--w-80 o-grid__cell--w-50@sm-and-up o-grid__cell--center-h o-grid__cell--slim o-grid__cell--w-35@lg-and-up">
								<img alt="Insurance contract picture" src="{{'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/insurance-icon-1.svg'}}">
							</div>
							<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-60@sm-and-up o-grid__cell--w-100@md-and-up o-grid__cell--center-h o-grid__cell--slim o-grid__cell--w-65@lg-and-up"
								 [ngClass]="{'o-grid__cell--w-65@lg-and-up': true}">
								<p class="c-text c-text--bold c-text--lg u-osb-md">
									{{ 'Claim.Submit_Claim' | translate }}
								</p>
								<p class="c-text c-text--lines u-osb-md">
									{{ 'Claim.Description' | translate }}
								</p>
								<a id="startClaimSubmitButton" [routerLink]="['/claim-request']" class="c-button c-button--s1 c-button--narrow c-button--fit@up-to-sm">
									{{ 'Claim.Submit' | translate }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="false" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up u-osb-md">
				<div class="c-card c-card--height-fit">
					<div class="c-content c-content--lg">
						<div class="o-grid o-grid--wrap o-grid--center-h">
							<div class="o-grid__cell o-grid__cell--w-80 o-grid__cell--w-50@sm-and-up o-grid__cell--center-h o-grid__cell--slim o-grid__cell--w-35@lg-and-up">
								<img src="{{'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/insurance-icon-2.svg'}}">
							</div>
							<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-60@sm-and-up o-grid__cell--w-100@md-and-up o-grid__cell--center-h o-grid__cell--slim o-grid__cell--w-65@lg-and-up"
								 [ngClass]="{'o-grid__cell--w-65@lg-and-up': true}">
								<p class="c-text c-text--bold c-text--lg u-osb-md">
									{{'Insurance.Policy.Buy_Insurance' | translate}}
								</p>
								<p class="c-text c-text--lines u-osb-md">
									{{'Insurance.Policy.Offers_From_Partners' | translate}}
								</p>
								<a class="c-button c-button--s1 c-button--narrow c-button--fit@up-to-sm">
									{{'Insurance.Policy.Learn_More' | translate}}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="c-section u-no-pb u-hidden@up-to-md" panel>
	<div class="c-section__content">
		<div class="o-grid o-grid--wrap">
			<div class="o-grid__cell o-grid__cell--w-100">
				<div class="c-tabs c-header__tabs u-no-mb">
					<a id="policyListTab" [routerLink]="['/insurance', 'policies']"
					   class="c-tabs__link"
					   [ngClass]="{ 'c-tabs__link--active': vm.tabCode === 'policies' }"
					   style="">
						{{'Insurance.Policy.My_Policies' | translate}}
					</a>
					<a id="claimListTab" [routerLink]="['/insurance', 'claims']" 
					   class="c-tabs__link"
					   [ngClass]="{ 'c-tabs__link--active': vm.tabCode === 'claims' }"
					   style="">
						{{ 'Claim.History' | translate }}
					</a>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="c-section c-section--last u-no-pb u-hidden@up-to-md" panel *ngIf="vm.tabCode === 'policies'">
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Insurance.Policy.My_Policies' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-insurance-policies></card-insurance-policies>
			</div>
		</div>
	</div>
</section>
<section class="c-section c-section--last u-no-pb u-hidden@up-to-md" panel *ngIf="vm.tabCode === 'claims'">
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Claim.History' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-claims-history></card-claims-history>
			</div>
		</div>
	</div>
</section>

<section class="c-section c-section--last u-no-pb u-hidden@md-and-up" panel>
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Insurance.Policy.My_Policies' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-insurance-policies></card-insurance-policies>
			</div>
		</div>
	</div>
</section>
<section class="c-section c-section--last u-no-pb u-hidden@md-and-up u-osb-md" panel>
	<div class="c-section__header">
		<p class="c-section__title u-hidden@md-and-up">{{ 'Claim.History' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<card-claims-history></card-claims-history>
			</div>
		</div>
	</div>
</section>
